import DatabaseManagerStore from "./views/admin/DatabaseManager/DatabaseManagerStore";
import { UIStore } from "@intrasync/stores/features";
import { SettingsStore } from "@intrasync/stores";
import { ServiceViewStore } from "@intrasync/react";
import BomExtractionViewStore from "./views/bom-extraction/BomExtractionViewStore";

// Import store lists from each view group
import projectManagementStoreList from "./views/projectManagement/viewStoresList";
import schedulingStoreList from "./views/scheduling/schedulingStoreList";
import inventoryAndFieldStoreList from "./views/inventoryAndField/inventoryAndFieldStoreList";
import yardStoreList from "./views/yard/yardStoreList";
import dispatchStoreList from "./views/dispatch/dispatchStoreList";
import productionStoreList from "./views/production/productionStoreList";
import qualityControlStoreList from "./views/qualityControl/qualityControlStoreList";
import administrationStoreList from "./views/administration/administrationStoreList";
import accountingStoreList from "./views/accounting/accountingStoreList";
import crmStoreList from "./views/crm/crmStoreList";
import productStoreList from "./views/product/productStoreList";
import purchasingStoreList from "./views/purchasing/purchasingStoreList";
import fieldReportingStoresList from "./views/fieldReporting/fieldReportingStoresList";
import pdfStoreList from "views/pdf/pdfStoreList";
import bomStoreList from "./views/bom/bomStoreList";
import materialsStoreList from "./views/materials/materialsStoreList";
import operationsStoreList from "./views/operations/operationsStoreList";
import workflowsStoreList from "./views/workflows/workflowsStoreList";
import millerMizeStoreList from "./views/millermize/viewStoresList";
import castStoneStoreList from "./views/castStone/castStoneStoreList";

const appStores = [
  // Core stores
  { name: "databaseManagerStore", store: DatabaseManagerStore },
  { name: "uiStore", store: UIStore },
  { name: "settingsStore", store: SettingsStore },
  { name: "serviceViewStore", store: ServiceViewStore },
  { name: "bomExtractionViewStore", store: BomExtractionViewStore },

  // View group stores
  ...projectManagementStoreList,
  ...schedulingStoreList,
  ...inventoryAndFieldStoreList,
  ...yardStoreList,
  ...dispatchStoreList,
  ...productionStoreList,
  ...qualityControlStoreList,
  ...administrationStoreList,
  ...accountingStoreList,
  ...crmStoreList,
  ...productStoreList,
  ...purchasingStoreList,
  ...fieldReportingStoresList,
  ...pdfStoreList,
  ...bomStoreList,
  ...materialsStoreList,
  ...operationsStoreList,
  ...workflowsStoreList,
  ...millerMizeStoreList,
  ...castStoneStoreList
];

export default appStores;
